// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JmsDo","right":"styles_right__204Cs"};